import {
  Component,
  HostListener,
  Inject,
  Input, PLATFORM_ID
} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {
  RACE_DETAILS,
  REGISTER_TO_RACE
} from "src/app/app-routing.module";
import {AbstractComponent} from "../abstract.component";
import {EventItem, Lookups, Race, RaceCommercialItem} from "@model";
import {RaceService} from "@services";
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-race-grid-item',
  templateUrl: './race-grid-item.component.html',
  styleUrls: ['./race-grid-item.component.scss']
})
export class RaceGridItemComponent extends AbstractComponent {
  @Input() race: Race | undefined;
  @Input() eventItem: EventItem | undefined;
  @Input() itemClass: string | undefined;
  @Input() logoPath: string | undefined;
  @Input() isLast: boolean = false;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() raceCommercialItems?: RaceCommercialItem[];
  @Input() currencyLabel: string | undefined;

  currentWindowWidth: number = 0;

  constructor(private raceService: RaceService, private router: Router,
              private route: ActivatedRoute, @Inject(PLATFORM_ID) private platformId: Object) {
    super();
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.currentWindowWidth = event.target.innerWidth;
  }


  onRegister(): void {
    if (this.race) {
      if (this.race.raceSettings?.registrationExternalUrl) {
        window.open(this.race.raceSettings.registrationExternalUrl);
      } else {
        this.router.navigate([REGISTER_TO_RACE], {
          relativeTo: this.route,
          queryParamsHandling: "merge",
          queryParams: {
            eventId: this.race.eventId,
            raceId: this.race.id
          },
        });
      }
    }
  }

  onMore(): void {
    if (this.race) {
      this.raceService.setCurrentRace(this.race);
      this.router.navigate([RACE_DETAILS], {
        relativeTo: this.route,
        queryParams: {eventId: this.race.eventId, raceId: this.race.id},
        queryParamsHandling: "merge"
      });
    }
  }

}
